(function() {
  const initStackingEffect = () => {
    if (window.innerWidth > 767) return;

    const fadeItems = document.querySelectorAll('.homepage-collection-withFade .js-fade-item');
    
    const observerOptions = {
      root: null,
      threshold: 0,
      rootMargin: "-120px 0px -88% 0px" // Adjusted to match the 'top' sticky value in CSS
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        // When the card passes the sticky point, it's considered "covered"
        if (!entry.isIntersecting && entry.boundingClientRect.top < 120) {
          entry.target.classList.add('is-covered');
        } else {
          entry.target.classList.remove('is-covered');
        }
      });
    }, observerOptions);

    fadeItems.forEach(item => observer.observe(item));
  };

  window.addEventListener('scroll', () => {
    // Optional: Extra smooth parallax can be added here if needed
  });

  document.addEventListener('DOMContentLoaded', initStackingEffect);
  document.addEventListener('shopify:section:load', initStackingEffect);
})();